(function($){

  __bind = function(fn, me){ return function(){ return fn.apply(me, arguments) } }

var Checker

Checker = (function() {

  function Checker($el, field) {
    this.run = __bind(this.run, this)

    var sel
    sel = field[0]
    this.element = $el
    this.metric = field[1]
    this.getVal = this.makeGetVal($el, sel)
  }

  Checker.prototype.run = function(e) {
    return {
      status: this.verify(),
      chain_status: e.autonod_status!==undefined? e.autonod_status : true
    }
  }

  Checker.prototype.makeGetVal = function($el, sel) {
    var inputs, name, type
    type = $el.attr('type')
    if (type === 'checkbox') {
      return function() {
        return $el.is(':checked')
      }
    } else if (type === 'radio') {
      name = $el.attr('name')
      return function() {
        return $('[name="' + name + '"]').filter(':checked').val()
      }
    } else if ($el.data('ckeditor') !== undefined) {
      return function() {
        var text = $el.data('ckeditor').getData()
        if ($el.data('language')) {
          text = JSON.stringify(text)
          text = text.substring(1, text.length - 1)
        }
        return text
      }
    } else if ($el[0].selectize !== undefined) {
      return function() {
        var vals = $el[0].selectize.getValue()
        return vals.length == 0 ? '' : vals
      }
    } else if ($el.hasClass('g-recaptcha')) {
      return function() {
        return typeof grecaptcha === "undefined" ? '' : grecaptcha.getResponse()
      }
    } else {
      if (this.metric === 'one-of') {
        inputs = $(sel)
        return function() {
          return inputs.map(function() {
            return this.value
          }).get().join('')
        }
      } else {
        return function() {
          var _value
          if ($el.data('ckeditor') !== undefined) {
            _value = $el.data('ckeditor').getData()
          } else {
            _value = $el.val()
          }
          if ($el.data('language')) {
            _value = JSON.stringify(_value)
            _value = _value.substring(1, _value.length - 1)
          }
          return _value
        }
      }
    }
  }

  Checker.prototype.verify = function() {
    var arg, sec, type, _ref
    if (this.element.prop('disabled')) {
      console.log('autonod::verify element is disabled, skipping')
      console.log(this.element)
      return true;
    }
    var m = this.metric
    var v = this.getVal()
    if (!!(m && m.constructor && m.call && m.apply)) {
      return m(v)
    }
    if (m instanceof RegExp) {
      return m.test(v)
    }
    _ref = $.map(m.split(':'), $.trim)
    type = _ref[0]
    arg = _ref[1]
    sec = _ref[2]
    if (type === 'same-as' && $(arg).length !== 1) {
      throw new Error('same-as selector must target one and only one element')
    }
    if (!v && type !== 'presence' && type !== 'one-of' && type !== 'same-as' && type !== 'trigger-change') {
      return true
    }
    switch (type) {
      case 'presence':
        return !!v
      case 'one-of':
        return !!v
      case 'exact':
        return v === arg
      case 'not':
        return v !== arg
      case 'same-as':
        return v === $(arg).val()
      case 'trigger-change':
        return true
      case 'min-num':
        return +v >= +arg
      case 'max-num':
        return +v <= +arg
      case 'between-num':
        return +v >= +arg && +v <= +sec
      case 'min-length':
        return v.length >= +arg
      case 'max-length':
        return v.length <= +arg
      case 'exact-length':
        return v.length === +arg
      case 'between':
        return v.length >= +arg && v.length <= +sec
      case 'integer':
        return /^-?\s*\d+\s*$/.test(v)
      case 'float-point':
        return /^[-+]?[0-9]+(\.[0-9]+)?$/.test(v)
      case 'float-comma':
        return /^[-+]?[0-9]+(,[0-9]+)?$/.test(v)
      case 'email':
        return this.email(v)
      default:
        throw new Error('I don\'t know ' + type + ', sorry.')
    }
  }

  Checker.prototype.email = function(v) {
    var RFC822
    RFC822 = /^([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22))*\x40([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d))*$/
    return RFC822.test(v)
  }

  return Checker

})()

var Listener

Listener = (function() {

  function Listener(form, el, get, field) {
    this.form = form
    this.get = get
    this.field = field
    this.changeStatus = __bind(this.changeStatus, this)
    this.runCheck = __bind(this.runCheck, this)
    this.delayedCheck = __bind(this.delayedCheck, this)

    this.element = $(el)
    this.delayId = ""
    this.status = null
    this.errorSent = null
    this.checker = new Checker(this.element, this.field)

    // when to run the listeners
    console.log('autonod::listener for ' + this.element.prop('name'))
    if (this.element.attr('type') === 'radio') {
      console.log('autonod::installing listener for radio')
      $('[name="' + this.element.attr("name") + '"]').on('change', this.runCheck)
    } else if (this.element[0].selectize !== undefined) {
      //The problem is that selectize is using it's own event system
      //and they don't pass an event variable to the handler, so
      //we would have to use multiple autonod checks for each element. We
      //use the jquery change instead.
      //var sel = this.element[0].selectize
      //sel.on('blur', this.runCheck)
      //sel.on('item_add', this.runCheck)
      //sel.on('item_remove', this.runCheck)
      console.log('autonod::installing listener for selectize')
      var element = this.element
      element.on('change', this.runCheck)
      element.parent('.form-group').find('input').on('blur', this.runCheck)
      element.parent('.form-group').find('input').on('change', this.runCheck)
    } else if (this.element.hasClass('g-recaptcha')) {
      console.log('autonod::installing listener for recaptcha')
      if (typeof _recaptchaCallbackRef === "undefined") {
        console.error('autonod::variable has not been set')
      } else {
        var _this=this
        _recaptchaCallbackRef = function() {
          return _this.runCheck({})
        }
      }
    //} else if (this.element.data('ckeditor') !== undefined) {
      // ckeditor has only a few jQuery combatible events.
      // we would normally use 'blur' but this is not necessary because
      // the textarea is getting updated by the same event so we handle
      // as a generic input that receives only 'change' events.
    } else {
      console.log('autonod::installing listener for default')
      var elements = this.element
      elements.on('change', this.runCheck)
      elements.on('blur', this.runCheck)
      if (this.get.delay) {
        elements.on('keyup', this.delayedCheck)
      }
    }
  }

  Listener.prototype.delayedCheck = function(e) {
    clearTimeout(this.delayId)
    return (this.delayId = setTimeout(this.runCheck, this.get.delay, e))

  }

  Listener.prototype.runCheck = function(e) {
    $.when(this.checker.run(e)).then(this.changeStatus)
    e.autonod_status = (e.autonod_status!==undefined ? e.autonod_status : true) && this.status
    if (typeof this.checker.metric == 'string' && this.checker.metric.startsWith('trigger-change')) {
      var _ref = $.map(this.field[1].split(':'), $.trim), type = _ref[0], target = _ref[1]
      $(target).trigger('change')
    }
  }

  //TODO: do we really need this?
  Listener.prototype.synchronousRunCheck = function(e) {
    this.changeStatus(this.checker.run(e))
    e.autonod_status = (e.autonod_status!==undefined ? e.autonod_status : true) && this.status
  }

  Listener.prototype.changeStatus = function(result) {
    var status = result.status
    var chain_status = result.chain_status
    var isCorrect = !!status
    var first_error_in_chain = this.status===false && chain_status===true
    console.log("autonod::chain_status field " + this.field + " metric:" + this.checker.metric + " status= " + status)
    if (this.status === isCorrect && !first_error_in_chain) {
      return
    }
    if (this.status === null && chain_status===true) {
      // errors have been added externally, remove everything
      this.get.removeError(this.form, this.element, this.errorSent, true)
      this.errorSent = null
    }

    this.status = isCorrect
    if(this.status) {
      this.get.removeError(this.form, this.element, this.errorSent, chain_status)
      this.errorSent = null
    } else {
      // addError is required to be able to detect if errorSent is already
      // present. note that since errors might be added from other modules
      // (e.g. ajax response handler) however, we assume that reset_status is
      // been called every time a message is added outside of this module.
      this.errorSent = this.get.addError(this.form,this.element,this.field[2],
        this.errorSent)
    }
  }

  Listener.prototype.reset_status = function() {
    this.status = null
  }

  return Listener

})()

var AutoNod

AutoNod = (function() {

  function AutoNod(form, options, fields) {
    this.form = form
    this.form[0].__autonod = this
    this.get = $.extend({
      'delay': 700,
      'addError': null,
      'removeError': null,
    }, options)

    if(this.get.addError === null) {
      console.error("AutoNod: you must set the addError parameter")
      return
    }

    if(this.get.removeError === null) {
      console.error("AutoNod: you must set the removeError parameter")
      return
    }

    var form=this.form
    if (!fields) {
      fields=[]
    }

    var need=function(e,f) {
      if(!e.data(f)) {
        console.error('AutoNod:missing data-'+f+' parameter for validation')
        return true
      }
      return false
    }

    form.find('[data-required]').each(function() {
      var e=$(this)
      if(e.data('autonod-required')) { return }
      e.data('autonod-required',true)
      fields.push([e,'presence',e.data('required-msg') || "Field is required"])
    })

    form.find('[data-exact]').each(function() {
      var e=$(this)
      if(e.data('autonod-exact')) { return }
      e.data('autonod-exact',true)
      if(need(e,'exact')) { return }
      fields.push([e,'exact:'+e.data('exact'),e.data('exact-msg') || "Field must match exactly"])
    })

    form.find('[data-not]').each(function() {
      var e=$(this)
      if(e.data('autonod-not')) { return }
      e.data('autonod-not',true)
      if(need(e,'not')) { return }
      fields.push([e,'not:'+e.data('not'),e.data('not-msg') || "Field must not be that"])
    })

    form.find('[data-maxlength]').each(function() {
      var e=$(this)
      if(e.data('autonod-maxlength')) { return }
      e.data('autonod-maxlength',true)
      if(need(e,'maxlength')) { return }
      var v=e.data('maxlength')
      fields.push([e,'max-length:'+v,e.data('maxlength-msg') || "No longer than "+v+" characters"])
    })

    form.find('[data-minlength]').each(function() {
      var e=$(this)
      if(e.data('autonod-minlength')) { return }
      e.data('autonod-minlength',true)
      if(need(e,'minlength')) { return }
      var v=e.data('minlength')
      fields.push([e,'min-length:'+v,e.data('minlength-msg') || "No smaller than "+v+" characters"])
    })

    form.find('[data-len]').each(function() {
      var e=$(this)
      if(e.data('autonod-len')) { return }
      e.data('autonod-len',true)
      if(need(e,'len')) { return }
      var v=e.data('len')
      fields.push([e,'exact-length:'+v,e.data('len-msg') || "Must be exactly "+v+" characters"])
    })

    form.find('[data-max]').each(function() {
      var e=$(this)
      if(e.data('autonod-max')) { return }
      e.data('autonod-max',true)
      if(need(e,'max')) { return }
      var v=e.data('max')
      fields.push([e,'max-num:'+v,e.data('max-msg') || "Number smaller than "+v])
    })

    form.find('[data-min]').each(function() {
      var e=$(this)
      if(e.data('autonod-min')) { return }
      e.data('autonod-min',true)
      if(need(e,'min')) { return }
      var v=e.data('min')
      fields.push([e,'min-num:'+v,e.data('min-msg') || "Number bigger than "+v])
    })

    form.find('[data-integer]').each(function() {
      var e=$(this)
      if(e.data('autonod-integer')) { return }
      e.data('autonod-integer',true)
      fields.push([e,'integer',e.data('integer-msg') || "Must be an integer"])
    })

    form.find('[data-float]').each(function() {
      var e=$(this)
      if(e.data('autonod-float')) { return }
      e.data('autonod-float',true)
      var decimalType = 'point'
      if (e.data('float-decimal-char') == ',') {
        decimalType = 'comma';
      } else if (e.data('float-decimal-char') == '.') {
        decimalType = 'point';
      }
      fields.push([e,'float'+'-'+decimalType,e.data('float-msg') || "Must be a real number"])
    })

    form.find('[data-same]').each(function() {
      var e=$(this)
      if(e.data('autonod-same')) { return }
      e.data('autonod-same',true)
      if(need(e,'same')) { return }
      var v=e.data('same')
      fields.push([e,'same-as:'+v,e.data('same-msg') || "Must be equal to another field"])
    })
    form.find('[data-trigger-change]').each(function() {
      var e=$(this)
      if(e.data('autonod-trigger-change')) { return }
      e.data('autonod-trigger-change',true)
      if(need(e,'trigger-change')) { return }
      var v=e.data('trigger-change')
      fields.push([e,'trigger-change:'+v,''])
    })

    form.find('[data-email]').each(function() {
      var e=$(this)
      if(e.data('autonod-email')) { return }
      e.data('autonod-email',true)
      fields.push([e,'email',e.data('email-msg') || "Must be a valid email (RFC 822)"])
    })

    form.find('[data-regex]').each(function() {
      var e=$(this)
      if(e.data('autonod-regex')) { return }
      e.data('autonod-regex',true)
      fields.push([e,new RegExp(e.data('regex')),e.data('regex-msg') || "Must match regex)"])
    })

    var get=this.get
    {
      listeners=this.listeners=[]
      _(fields).each(function(field) {
        if (field.length !== 3) {
          console.log('autonod::Metrics for each field must have three parts: '+field)
          return
        }
        console.log(field)
        _(form.find(field[0])).each(function(el) {
          listeners.push(new Listener(form, el, get, field))
        })
      })
    }
  }

  AutoNod.prototype.checkAll = function() {
    var pseudoEvent = {}
    _(this.listeners).each(function(l) {
      l.synchronousRunCheck(pseudoEvent)
    })
    return (pseudoEvent.autonod_status!==undefined ? pseudoEvent.autonod_status : true)
  }

  AutoNod.prototype.resetStatus = function() {
    _(this.listeners).each(function(l) {
      l.reset_status()
    })
  }

  return AutoNod

})()

$.fn.autonod = function(settings, fields) {
  if (!(fields || settings)) {
    return this[0].__autonod
  }
  return new AutoNod(this, settings, fields)
}

})(jQuery)
